import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/list-chevrons-up-down.vue
var o = {
	name: "DtIconListChevronsUpDown",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--list-chevrons-up-down"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "List Chevrons Up Down",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M5.5 9a.5.5 0 0 1 0 1h-4a.5.5 0 1 1 0-1h4Zm4.646-1.354a.5.5 0 1 1 .707.707l-1.5 1.5a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 1 1 .708-.707L9 8.793l1.146-1.147ZM5.5 5.5a.5.5 0 0 1 0 1h-4a.5.5 0 1 1 0-1h4Zm3.225-3.418a.5.5 0 0 1 .629.064l1.5 1.5a.5.5 0 1 1-.707.707L9 3.207 7.854 4.353a.5.5 0 1 1-.708-.707l1.5-1.5.079-.064ZM5.5 2a.5.5 0 0 1 0 1h-4a.5.5 0 1 1 0-1h4Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=list-chevrons-up-down.js.map